import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/components/main-layout.js";
import { Button } from '@undertheground/react';
import colors from '@undertheground/color';
import ButtonCover from '../images/ButtonIcon/ButtonCover.png';
import LabelOnly from '../images/ButtonIcon/LabelOnly.png';
import LabelWithIcon from '../images/ButtonIcon/LabelWithIcon.png';
import IconOnly from '../images/ButtonIcon/IconOnly.png';
import LabelOnlyPadding from '../images/ButtonIcon/LabelOnlyPadding.png';
import LabelWithIconPadding from '../images/ButtonIcon/LabelWithIconPadding.png';
import GhostPadding from '../images/ButtonIcon/GhostPadding.png';
import IconOnlyPadding from '../images/ButtonIcon/IconOnlyPadding.png';
import ScalingResponsive from '../images/ButtonIcon/ScalingResponsive.png';
import ScalingWeb from '../images/ButtonIcon/ScalingWeb.png';
import ScalingWithIconCorrect from '../images/ButtonIcon/ScalingWithIconCorrect.png';
import ScalingWithIconWrong from '../images/ButtonIcon/ScalingWithIconWrong.png';
import PrimaryBtnStates from '../images/ButtonIcon/PrimaryBtnStates.png';
import SecondaryBtnStates from '../images/ButtonIcon/SecondaryBtnStates.png';
import GhostBtnStates from '../images/ButtonIcon/GhostBtnStates.png';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <style>{`

img {

}
.header {
    color: #D1036F;
}
.sub-header{
    font-weight:500;
}

.code-snippet {
    background-color: ${colors.grey[9]};
    width:100%;
}

.fraction-size {
    height: 30rem
}

.container{
    display:inline-flex;
    width:100%;
}

.btn-primary::after {
    content:'';
    border-bottom:0.1rem solid ${colors.grey[2]};
    width:100%;
    display:block;
}

.btn-ghost::after{
    content:'';
    border-bottom:0.1rem solid ${colors.grey[2]};
    width:100%;
    display:block;
}

.row-1 , .row-2{
    width:50%;
    text-align:center;
}

.btn-row_1{
    border-right:0.1rem solid ${colors.grey[2]};
}

.icon-only_preview{
    vertical-align:middle;
}

.btn-arrangment{
    margin:3rem;
}

.tabel{
    overflow: scroll; /* Scrollbar are always visible */
    overflow: auto;   /* Scrollbar is displayed as it's needed */
    display:grid;
    width:100%;
}

.button-variant-table td{
    color:${colors.pink[3]} ;
}

h6 {
    height:30px
}
.anatomy-table{
    margin:0 auto;
    display:flex;
}

.label-btn_img{
    margin: 1rem 0 2rem; 
    height: 8rem;
}

.icon-only_img{
    margin: 2.8rem 0 1rem; 
    height: 6rem;
}

.label-with_icon__img{
    margin: 1rem 0 1rem; 
    height: 11rem;

}

.row{
    display:flex;
    margin:0 auto;
}

.btn-anatomy{
    margin:0 4rem;
}


.img-margin{
    margin:4rem;
}


.img-box{
    margin:1.6rem 6rem; 
}

.box{
    margin:1.6rem 6rem;
    width:50%; 
}

.btn-states_img{
    width:60%;
    margin: 3rem auto;
}
.edit-git {
    color: ${colors.grey[3]};
    text-decoration: none;
}
@media (max-width:1024px){
    .btn-anatomy{
        margin:0 3rem;
    }
    .img-box{
        margin: 0.4rem 4.5rem;
    }
}

@media (max-width:790px){
    .main-container {
        margin-left: 0.5rem !important;
        margin-right: 0.5rem !important;
        padding-top: 5rem
    }
    .image-responsive {
        display: none;
    }
    .row{
        display:grid;
        margin:0 auto;
    }
    .btn-anatomy{
        margin-bottom:3rem;
    }
    .label-btn_img{
        margin-bottom:0;
    }
    .label-with_icon__img{
        margin-bottom:0;
    }
    .icon-only_img {
     margin: 0.8rem 0 1rem;
    }
    .img-margin {
        margin: 1rem;
    }
    .scaling-img{
        height:16rem;
    }
    .scaling-box{
        text-align:center;
    }
    .arrangment-img{
        width: 19rem;
    }
    .box{
        margin:2rem auto;
        width:44%;
    }
    .btn-states_img{
        width:80%;
        margin: 3rem auto;
    }
    
    @media (max-width:600px){
        .container{
            display:grid;
        }
        .btn-row_1 {
            border-right: 0rem;
        }
        .row-1, .row-2 {
            width: 100%;
   
        }
        .btn-secondary::after {
            content: '';
            border-bottom: 0.1rem solid #BABABA;
            width: 100%;
            display: block;
        }
        .img-box{
             margin: 0.4rem 2.5rem;
        }
        .box{
     
            width:74%;
        }
        .btn-states_img{
            width:100%;
            margin: 2rem auto;
        }
    }
}



`}</style>
    <img className={'image-responsive'} style={{
      width: '100%'
    }} src={ButtonCover} />
    <div className={'main-container'} style={{
      marginLeft: '12rem',
      marginRight: "6rem"
    }}>
      <h1>{`Button`}</h1>
      <h6></h6>
      <h2>{`Table of Content`}</h2>
      <p><a parentName="p" {...{
          "href": "#overview"
        }}>{`OVERVIEW`}</a>{`  `}</p>
      <p><a parentName="p" {...{
          "href": "#button-variants"
        }}>{`BUTTON VARIANTS`}</a></p>
      <p><a parentName="p" {...{
          "href": "#anatomy"
        }}>{`ANATOMY`}</a></p>
      <p><a parentName="p" {...{
          "href": "#specs"
        }}>{`SPECS`}</a></p>
      <p><a parentName="p" {...{
          "href": "#behavior"
        }}>{`BEHAVIOR`}</a></p>
      <h6></h6>
      <h2>{`Overview`}</h2>
      <p>{`Buttons are clickable elements that are used to trigger actions.
They communicate calls to action to the user and allow users to interact with pages in a variety of ways. Button labels
express what action will occur when the user interacts with it.`}</p>
      <h5 className={'header'}>When to use</h5>
      <p>{`Use buttons to communicate actions users can take and to allow users to interact with the page.
Each page should have one primary button, and any remaining calls to action should be represented as lower emphasis buttons.`}</p>
      <h5 className={'header'}>When not to use</h5>
      <p>{`Do not use buttons as navigational elements. Instead, use links when the desired action is to take the user to a new page.`}</p>
      <h6></h6>
      <h2>{`Usage`}</h2>
      <p>{`A button with `}<inlineCode parentName="p">{`kind`}</inlineCode>{`, `}<inlineCode parentName="p">{`iconMode`}</inlineCode>{` and `}<inlineCode parentName="p">{`iconName`}</inlineCode>{` attributes has been represented below. `}</p>
      <h3>{`Live Demo`}</h3>
      <pre><code parentName="pre" {...{
          "className": "language-js"
        }}>{`

<Button kind={"primary"} iconMode={"with-icon"} iconName={"chevron_right"}>Button</Button>


`}</code></pre>
      <h6></h6>
      <h2>{`Button Variants`}</h2>
      <p>{`Each button variant has a particular function and its design signals that function to the user.
It is therefore very important that the different variants are implemented consistently across products,
so that they message the correct actions.`}</p>
      <h6></h6>
      <div className="code-snippet">
  <div className="container container-btn_varient">
        <div className="row-1 btn-row_1">
            <div className="btn-primary">
                <Button className="btn-arrangment" kind="primary" mdxType="Button">Button</Button>
            </div>
            <div className="btn-secondary">
                <Button className="btn-arrangment" kind="secondary" mdxType="Button">Button</Button>
            </div>
        </div>  
        <div className="row-2 btn-row_2">  
            <div className="btn-ghost">
                <Button className="btn-arrangment" kind="ghost" mdxType="Button">Button</Button>
            </div>
            <div className="btn-icon-only">
                <Button className="icon-only_preview btn-arrangment" kind="primary" iconMode="icon-only" iconName="search" mdxType="Button"></Button>
            </div>
        </div>    
    </div> 
      </div>
      <div className="button-variant-table tabel">
        <table>
          <thead parentName="table">
            <tr parentName="thead">
              <th parentName="tr" {...{
                "align": null
              }}>{`Varients`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`Purpose`}</th>
            </tr>
          </thead>
          <tbody parentName="table">
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`Primary`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`The primary button is designed for the call to action and it should have high contrast with the whole page cause it should have a strong visual weight. Primary buttons should only appear once per screen (not including the application header, modal dialog, or side panel), in summery primary button should be used where the platform wants to strongly suggest something that the user should do.`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`Secondary`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`The secondary button is designed for secondary actions. Secondary actions should have less visual weight because we assume that majority of users will go with the primary action. Secondary actions are actions like the cancel button next to submit button. In “Wish Work” we use outline buttons for secondary actions.`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`Ghost`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`Ghost button is usually used for miscellaneous actions,  the action is important, but it may not be the action that the user wishes for (looking for). For instance, ‘edit action’ or ‘add new’  for changing information is an important action but it is not a primary action.`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`Icon-only`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`Icon buttons have no label and are only an icon. Because they don’t have a label, they save a lot of space in an interface. Icon buttons also allow you to stack other icon buttons next to them in a small space. But you have to be concerned that the icon that you use without any label should represent itself clearly and do not confuse the user.`}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <h6></h6>
      <h2>{`Anatomy`}</h2>
      <p>{`The main element in buttons is the label of that button, as it represents the action that will be performed when the user interacts with it.
All buttons label are hold placed in the center. Even with icon, the group of label and icon should be in the center of button.`}</p>
      <h6></h6>
      <div className="container">
    <div className="row">
        <div className="label-btn btn-anatomy">
            <h6>1. Label only </h6>
            <div>
                <img className="label-btn_img" src={LabelOnly} alt="Label Only Button" />
            </div>
        </div>
        <div className="label-with_icon btn-anatomy">
            <h6> 2. Label with icon</h6>
            <div>
                <img className={"label-with_icon__img"} src={LabelWithIcon} alt="Label With Icon Button" />
            </div>
        </div>
        <div className="icon-only_btn btn-anatomy">
            <h6> 3. Icon-only</h6>
            <div>
                <img className={"icon-only_img"} src={IconOnly} alt="Icon Only Button" />
            </div>
        </div>
        
    </div>
      </div>
      <div className="anatomy-table tabel tabel">
        <table>
          <thead parentName="table">
            <tr parentName="thead">
              <th parentName="tr" {...{
                "align": null
              }}>{`1. Label only`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`2. Label with icon`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`3. Icon-only`}</th>
            </tr>
          </thead>
          <tbody parentName="table">
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`A. Text label`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`A. Text label`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`A. Icon`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`B. Container`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`B. Container`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`B. Container`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`C. ---`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`C. Icon`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`C. ---`}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <h6></h6>
      <h2>{`Specs`}</h2>
      <p>{`Each type of button has its own attributes, that we gonna mention below.`}</p>
      <ul>
        <li parentName="ul">{`Margin`}</li>
      </ul>
      <ul>
        <li parentName="ul">{`Padding`}</li>
      </ul>
      <ul>
        <li parentName="ul">{`Font`}</li>
      </ul>
      <ul>
        <li parentName="ul">{`Radius`}</li>
      </ul>
      <ul>
        <li parentName="ul">{`Stroke`}</li>
      </ul>
      <div className="specs">
    <div className="container">
        <div className="row-1">
            <div className="img-margin">
                <img src={LabelOnlyPadding} style={{
                width: '100%'
              }} alt="Label Only Button Paddings" />
            </div>
            <div className="img-margin">
                <img src={LabelWithIconPadding} style={{
                width: '100%'
              }} alt="Label With Icon Button Paddings" />
            </div>
        </div>
        <div className="row-2">
            <div className="img-margin">
                <img src={GhostPadding} style={{
                width: '100%'
              }} alt="Ghost Button Paddings" />
            </div>
            <div className="img-margin">
                <img src={IconOnlyPadding} style={{
                width: '100%'
              }} alt="Icon Only Button Paddings" />
            </div>
        </div>        
    </div>
      </div>
      <h6></h6>
      <h3>{`Label button attributes`}</h3>
      <div className="label-btn-tabel tabel">
        <table>
          <thead parentName="table">
            <tr parentName="thead">
              <th parentName="tr" {...{
                "align": null
              }}>{`Varient`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`Margin(px/ rem)`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`Padding(px/ rem)`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`Radius(px/ rem)`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`Stroke(rem)`}</th>
            </tr>
          </thead>
          <tbody parentName="table">
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`Primary`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`1rem`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`left and right 52/3.25`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`4/0.25`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`0.14rem solid transparent`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`Secondary`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`1rem`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`left and right 52/3.25`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`4/0.25`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`0.14rem solid #1C5BC2`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`Ghost`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`1rem`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`left and right 52/3.25`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`4/0.25`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`0.14rem solid transparent`}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <h6></h6>
      <h3>{`Label with icon button attributes`}</h3>
      <div className="label-btn-tabel tabel">
        <table>
          <thead parentName="table">
            <tr parentName="thead">
              <th parentName="tr" {...{
                "align": null
              }}>{`Varient`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`Margin(px/ rem)`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`Padding(px/ rem)`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`Radius(px/ rem)`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`Stroke(rem)`}</th>
            </tr>
          </thead>
          <tbody parentName="table">
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`Primary`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`1rem`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`left and right 52/3.25`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`4/0.25`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`0.14rem solid transparent`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`Secondary`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`1rem`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`left and right 52/3.25`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`4/0.25`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`0.14rem solid #1C5BC2`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`Ghost`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`1rem`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`left and right 52/3.25`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`4/0.25`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`0.14rem solid transparent`}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <h6></h6>
      <h3>{`Icon-only button attributes`}</h3>
      <div className="label-btn-tabel tabel">
        <table>
          <thead parentName="table">
            <tr parentName="thead">
              <th parentName="tr" {...{
                "align": null
              }}>{`Varient`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`Margin(px/ rem)`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`Padding(px/ rem)`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`Radius(px/ rem)`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`Stroke(rem)`}</th>
            </tr>
          </thead>
          <tbody parentName="table">
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`Primary`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`1rem`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`left and right 52/3.25`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`4/0.25`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`0.14rem solid transparent`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`Secondary`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`1rem`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`left and right 52/3.25`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`4/0.25`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`0.14rem solid #1C5BC2`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`Ghost`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`1rem`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`left and right 52/3.25`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`4/0.25`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`0.14rem solid transparent`}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <h6></h6>
      <h2>{`Behavior`}</h2>
      <p>{`Each button can act diffrently in diffrent situations,
like when user does not fullfield the requirement inputs and want
to submit the form, in that situation the button should be disable until the user completed the form`}</p>
      <ul>
        <li parentName="ul">{`Scaling`}</li>
      </ul>
      <ul>
        <li parentName="ul">{`Arrangment`}</li>
      </ul>
      <ul>
        <li parentName="ul">{`Animation`}</li>
      </ul>
      <ul>
        <li parentName="ul">{`States`}</li>
      </ul>
      <ul>
        <li parentName="ul">{`Skeleton loading`}</li>
      </ul>
      <h6></h6>
      <h3>{`Scaling`}</h3>
      <p>{`When scaling layouts for large screen devices, buttons can adapt their visual presentation,
alignment, and arrangement to fit different contexts and user needs. Buttons usually depends on their
parents like the containers that they are placed in.`}</p>
 <div className="scaling">
    <div className="container">
        <div className="row">
            <div className="img-box scaling-box">
                <img src={ScalingResponsive} style={{
                width: '100%'
              }} className="scaling-img" />
            </div>
            <div className="img-box scaling-box">
                 <img src={ScalingWeb} style={{
                width: '100%'
              }} className="scaling-img" />
            </div>
        </div>
    </div>         
 </div>
      <ul>
        <li parentName="ul">{`A button’s position and size should scale in relationship to its container.`}</li>
      </ul>
      <h6></h6>
      <h3>{`Arrangment`}</h3>
      <p>{`Define the position and alignment of button elements such as text and icons in relationship to their container.
For example, the icon and text label within a button remain centered and anchored to each other as the button width scales.`}</p>
      <ul>
        <li parentName="ul">{`Note one:`}</li>
      </ul>
      <div className="Arrangment">
    <div className="container">
        <div className="row">
            <div className="img-box">
                <img src={ScalingWithIconCorrect} style={{
                width: '100%'
              }} className="arrangment-img" />
            </div>
            <div className="img-box">
                 <img src={ScalingWithIconWrong} style={{
                width: '100%'
              }} className="arrangment-img" />
            </div>
        </div>
    </div>    
    <div className="container">
        <div className="row">
                <p className="box">
                    Do <br />
                    Group internal elements so that they scale appropriately. 
                    Icons and text labels remain centered when button width increases.
                </p>
                <p className="box">
                    Don't <br />
                    Don’t ungroup elements inside of a button container.
                     This can lead to unwanted movement, such as the icon and label 
                     anchoring to opposite sides of the button.
                </p>
        </div>
    </div>     
      </div>
      <ul>
        <li parentName="ul">{`Note two:`}</li>
      </ul>
      <p>{`The size and placement of buttons can change as parent containers, such as cards, adapt for larger screens.`}</p>
      <h6></h6>
      <h3>{`States`}</h3>
      <h6></h6>
      <div className="btn-states">
    <h4 className="sub-header">Primary button states</h4>
    <div className="row">
        <img src={PrimaryBtnStates} className="btn-states_img" />
    </div>
    <h4 className="sub-header">Secondary button states</h4>
    <div className="row">
        <img src={SecondaryBtnStates} className="btn-states_img" />
    </div>
    <h4 className="sub-header">Ghost button states</h4>
    <div className="row">
        <img src={GhostBtnStates} className="btn-states_img" />
    </div>
      </div>
      <a className="edit-git" href="https://github.com/undertheground/under-the-ground-website/blob/main/src/pages/buttondoc.mdx">Edit this page on GitHub</a>
    </div>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      